// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__H7bTy","quotation_container":"admin_console_quotation_container__VF6bl","areas_container":"admin_console_areas_container__-ekJO"};